import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./common/Navbar";
import HomePage from "./pages/Homepage";
import Footer from  "./common/Footer"
import FishFeedApp from "./pages/fishFeedProducts";
import ScrollToTop from "./component/scrolltotop";
import FishPage from "./pages/fishProducts"
import ContactPage from "./pages/ContactPage"
import AboutUsPage from "./pages/AboutUsPage"


const App = () => {
  return (
    <BrowserRouter>
      <Navbar />
      <ScrollToTop/>
      {/* Bottom padding on mobile so pages don't hide under the fixed bottom nav */}
      <main className="pb-16 md:pb-0">
        <Routes>
          <Route path="/" element={<HomePage />} />
          {/* Add more routes as needed */}
          <Route path="/fish-food" element={<FishFeedApp />} />
          <Route path="/fish" element={<FishPage />} />
          <Route path="/about" element={<AboutUsPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
      </main>
              <Footer />

    </BrowserRouter>
  );
}

export default App;
